import { ChangeAvatarRequest, UserControllerApi } from "../services";
import { getConfigObject, useMutationWithLoading } from "../utils/utils";

/**
 * @author rajkumar rathod
 */
export const useProfileAvatar = () =>
  useMutationWithLoading(
    async (params: { newAvatar: ChangeAvatarRequest; xTENANTID?: string }) =>
      new UserControllerApi(getConfigObject()).changeAvatar4(
        params.newAvatar,
        params?.xTENANTID
      )
  );
